/**
 * @generated SignedSource<<959b32eb12f8ab714176e33a47df47c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientBodyMeasurementsOutputFragment$data = ReadonlyArray<{
  readonly node: {
    readonly bodyMassIndex: number | null;
    readonly date: any;
    readonly height: number | null;
    readonly id: string;
    readonly weight: number;
  };
  readonly " $fragmentType": "PatientBodyMeasurementsOutputFragment";
}>;
export type PatientBodyMeasurementsOutputFragment$key = ReadonlyArray<{
  readonly " $data"?: PatientBodyMeasurementsOutputFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientBodyMeasurementsOutputFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PatientBodyMeasurementsOutputFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BodyMeasurement",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyMassIndex",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BodyMeasurementsEdge",
  "abstractKey": null
};

(node as any).hash = "b858f6a85c6a40c6c29776bed057b9bb";

export default node;
